import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { VuCommunicationService } from '../../services/vu-communication.service';
import { DOCUMENT } from '@angular/common';
import { TouchKeyboardService } from '../../services/touch-keyboard.service';
import { OrderStateService } from '../../../order/services/order-state.service';
import { map, mapTo, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-enable-vu-mode',
  templateUrl: './enable-vu-mode.component.html',
  styleUrls: ['./enable-vu-mode.component.css']
})
export class EnableVUModeComponent implements OnInit {

  readonly profileQueryParameterName = 'profile';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private shopSettingsService: ShopSettingsService,
    private vuCommunicationService: VuCommunicationService,
    private touchKeyboardService: TouchKeyboardService,
    @Inject(DOCUMENT) private document: Document,
    private orderStateService: OrderStateService,
  ) {
  }

  ngOnInit(): void {
    this.orderStateService.sessionOrderId = 0;
    this.shopSettingsService.isVUMode = true;
    this.document.body.classList.add('no-select');
    this.document.body.classList.add('no-drag');
    this.document.body.classList.add('vu-mode');

    this.activatedRoute.queryParams
      .pipe(
        switchMap(params => {
          const profile = params[this.profileQueryParameterName];
          if (this.shopSettingsService.profile === profile) {
            return of(params);
          }
          this.shopSettingsService.profile = profile;
          return this.shopSettingsService.initialize().pipe(mapTo(params));
        })
      )
      .subscribe(params => {
        this.vuCommunicationService.initialize();
        this.touchKeyboardService.hide();
        this.router.navigate(['']);
      });
  }
}
